import script from "./PromoFideliteView.vue?vue&type=script&setup=true&lang=js"
export * from "./PromoFideliteView.vue?vue&type=script&setup=true&lang=js"

import "./PromoFideliteView.vue?vue&type=style&index=0&id=48d8b0de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48d8b0de"]])

export default __exports__